import { utils } from '@/helpers';

export const LoyaltyAppSettingsPages = {
	info: {
		label: 'App Info',
	},
	styling: {
		label: 'App Styling',
	},
	features: {
		label: 'App Features',
	},
	verbiage: {
		label: 'App Verbiage',
	},
	admin: {
		label: 'App Admin',
	},
} as const;

export type LoyaltyAppSettingsPage = keyof typeof LoyaltyAppSettingsPages;

export function getLoyaltyAppPageFromParam(page: string): LoyaltyAppSettingsPage {
	if (page in LoyaltyAppSettingsPages) {
		return page as LoyaltyAppSettingsPage;
	}
	return 'info';
}

export function hasLoyaltyAppV2Enabled(): boolean {
	return (utils.user.loyaltyAppVersion ?? 0) > 0;
}
